// extracted by mini-css-extract-plugin
export default {"Snineth":"Snineth_Snineth__n2r9H","wrap":"Snineth_wrap__1wiU+","text":"Snineth_text__4h42a","title":"Snineth_title__johpY","desc":"Snineth_desc__AeBVe","img":"Snineth_img__n3SCi"};